module.exports = __webpack_public_path__ + "static/media/45.2aacaa9e.mp3";